import IntroductionComponent from "../components/IntroductionComponent";
import SkillsComponent from "../components/SkillsComponent";
import ProjectContainer from "../containers/ProjectsContainer";
import AddOnComponent from "../components/AddOnComponent";
import ExtraInfoComponent from "../components/ExtraInfoComponent";

const HomePage = () => {
    return (
        <div className="bg-primary">
            <IntroductionComponent/>
            <SkillsComponent/>
            <ProjectContainer slice={3}/>
            <AddOnComponent/>
            <ExtraInfoComponent/>
        </div>
    );
}

export default HomePage;